import { IssueTaskDoc, issueTaskCategoryMap } from '@gooduncles/gu-app-schema';
import { Popover } from 'antd';
import { formatDate, parseISO } from 'date-fns';
import { lowerCase } from 'lodash-es';
import { FC } from 'react';

import { formatNumber } from 'src/utils/common';

import classes from './TaskSpotCard.module.scss';

interface IssueTaskBadgeProps {
  task: IssueTaskDoc;
}

const IssueTaskBadge: FC<IssueTaskBadgeProps> = ({ task }) => {
  return (
    <Popover
      title={
        task.targetDate
          ? formatDate(parseISO(task.targetDate), 'yyyy-MM-dd')
          : formatDate(parseISO(task.registeredAt), 'yyyy-MM-dd')
      }
      content={
        <div>
          {task.privateNote && <p>{task.privateNote}</p>}
          {task.products &&
            task.products.map((product, idx) => (
              <p key={idx}>
                {product.productName} {product.quantity && <span>{product.quantity}개</span>}
              </p>
            ))}
          {task.amount && task.amount.totalAmount !== 0 && <p>금액: {formatNumber(task.amount.totalAmount)}원</p>}
        </div>
      }>
      <span className={`${classes.issue} ${task.category ? classes[lowerCase(task.category)] : ''}`}>
        {issueTaskCategoryMap[task.category]}
      </span>
    </Popover>
  );
};

export default IssueTaskBadge;
